import {
  MenuAvailabilitySchema,
  type MenuAvailability as GeneratedMenuAvailability
} from '~/services/api/generated'

export type MenuAvailability = GeneratedMenuAvailability

export const MenuAvailability = {
  ALWAYS: MenuAvailabilitySchema.enum.always,
  SCHEDULED: MenuAvailabilitySchema.enum.scheduled,
  TIME_BASED: MenuAvailabilitySchema.enum['time-based'],
  SEASONAL: MenuAvailabilitySchema.enum.seasonal
} satisfies Record<string, GeneratedMenuAvailability>

export const MenuAvailabilityValues: readonly GeneratedMenuAvailability[] = [
  MenuAvailabilitySchema.enum.always,
  MenuAvailabilitySchema.enum.scheduled,
  MenuAvailabilitySchema.enum['time-based'],
  MenuAvailabilitySchema.enum.seasonal
]
